<style lang="scss" scoped>
	.order-overlay {
	  display: block;
	  z-index: 9000;
	  position: absolute;
	  top: 0;
	  bottom: 0;
	  left: 0;
	  right: 0;
	  background: rgba(212, 224, 224, 0.7);
	  transition: opacity 500ms;
	  visibility: visible;
	  opacity: 1;
	  background-image: url("https://i.imgur.com/iqaIKcf.gif");
	  background-size: 70px 70px;
	  background-position: 50% 200px;
	  background-repeat: no-repeat;
	}

	.order-confirmation{
		.page-title{
			margin-top: 20px;
			.title{
				font-size : 2rem;
			}
		}

		.status{
			font-size: 14px;
		}

		.order-success{
			color : #00D38A !important;
		}

		.order-pending{
			color: #595E63 !important;
		}

		.text{
			font-size: 12px !important;
			margin-bottom: 0rem;
		}
	}
</style>

<template>
	<div class="order-confirmation">
		<div class="page-content">
			 <div class="padding p-b-0 top-section">
                <div class="page-title m-b">
                    <h1 class="inline m-a-0 title" :style="$highlightColor">ORDER CONFIRMATION</h1>
                </div>
				<div v-if="order">
					<div class="row">
						<div class="col-md-12 text-left" :style="$mainSecondaryTextStyle">
							<h3 class="status" :class="{'order-success': completed , 'order-pending' : !completed}">{{ completed }}</h3>
							<p class="text">Order Number : {{ order.number }} </p>
              <p class="text">Thank you {{order.customerName}} for your order. <template v-if="hasDownloadLinks">Here are your download links:</template></p>
						</div>
					</div>

					<items :order="order" :style="$mainPrimaryTextStyle"></items>
					<br>
					<p class="text" :style="$mainSecondaryTextStyle"> An email has also been sent to {{order.customerEmail}} with your order confirmation and download links. </p>
					<p class="text" :style="$mainSecondaryTextStyle"> Please contact {{producer.name}} via his email <strong>{{order.sellerEmail}}</strong> quoting your order number {{ order.number}} if you have any questions.</p>
				</div>
        <transition name="c-fade-transition">
          <order-overlay v-if="order && !order.completed" />
        </transition>
			</div>
		</div>
	</div>
</template>

<script>
import items from './../order/items.vue'
import Configure from './../../mixins/configure'
import OrderOverlay from "../order/order-overlay";
export default {
	mounted () {
		this.setOrder()
	},
	mixins: [Configure],
	components : {
    OrderOverlay,
		items
	},
	data () {
		return {
			order: null,
			user : ab.loggedInUser,
			producer : ab.user
		}
	},
	computed: {
		completed () {
			return (this.order.completed) ? "Order Success" : "Order Pending";
		},
        hasDownloadLinks() {
            const {
                collections,
                kits,
                beats,
                songs
            } = this.order

            return collections?.length || kits?.length || beats?.length || songs?.length
        }
	},
	methods: {
		setOrder () {
			if (ab.order) {
				this.order = ab.order
				this.completeOrder()
			} else {
				this.$router.push('/')
				this.$router.go(1)
			}
		},
		completeOrder () {
			if (! this.order.completed) {
				setTimeout(() => {
					this.$http.get(`${ab.apiUrl}/orders/${this.order.number}/completed`)
					.then(()=> {
            /**
             * Force reloading the page as a workaround for the missing wav/trackouts download urls
             * from the `ab.order` object when paying with PayPal before the payment is completed.
             * */
            location.reload()
						// this.order.completed = true
					}).catch((error) => {
						this.completeOrder()
					})
				}, 3000)
			}
		}
	},
	watch: { }
}
</script>
